export default function IconArrowDown({ className }: { className?: string }) {
    return (
        <svg
            className={className}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M24.59 16.59L17 24.17V4H15V24.17L7.41 16.59L6 18L16 28L26 18L24.59 16.59Z"
                fill="currentColor"
            />
        </svg>
    )
}
